/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")
@file:OptIn(ExperimentalJsExport::class)
package features.userDelete

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.Result.Idle
import kangaroorewards.appsdk.core.domain.Result.Loading
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kangaroorewards.appsdk.core.utils.CFlow
import kangaroorewards.appsdk.core.utils.asCFlow
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.mapLatest
import kotlinx.serialization.InternalSerializationApi
import kotlin.js.ExperimentalJsExport
import features.userDelete.internal.UserDeleteUseCase
import features.userDelete.internal.UserDeleteUseCase.Params
import kangaroorewards.appsdk.core.io.EmptyResponse


typealias UserDeleteState = CFlow<UserDeleteUseCaseResult?>

typealias UserDeleteUseCaseResult = Result<EmptyResponse>

fun UserDeleteUseCaseResult.serializeUserDeleteApiResult(): SerializedResult<String> {
    return this.toJsonResult<EmptyResponse>()
}

/**
 * Serializes [UserDeleteState]'s data and returns a new
 * [CFlow] containing data serialized as a JSON [String].
 */
@OptIn(ExperimentalCoroutinesApi::class)
fun UserDeleteState.serializeUserDeleteState(): CFlow<SerializedResult<String>?> {
    return this.mapLatest {
        it?.toJsonResult<EmptyResponse>()
    }.asCFlow()
}

/**
 * Delete user account  [Api] class
 */
class UserDeleteApi : Api() {

    val userDeleteState: UserDeleteState
        get() = _userDeleteState.asCFlow()

    companion object {
        private val _userDeleteState: MutableStateFlow<UserDeleteUseCaseResult> = MutableStateFlow(Idle())
    }

    private val userDeleteUseCase = UserDeleteUseCase()

    /**
     * Delete user account 
     */
    suspend fun deleteUserAccount(
        overrideHeaders: Map<String, String>? = null,

    ): Result<EmptyResponse> {
        /* set state to Loading as soon as function is called */
        _userDeleteState.value = Loading()
        val result = this.userDeleteUseCase(
            Params(
                overrideHeaders = overrideHeaders,

            )
        
        ) { result ->
            _userDeleteState.value = result
            return@userDeleteUseCase result
        }
        return result
    }

}
